export default "__VITE_ASSET__DcaTZUSz__"